import angular from 'angular';
import uiPagination from 'angular-ui-bootstrap/src/pagination';
import uiModal from 'angular-ui-bootstrap/src/modal';
import {crud} from '../common/crud/crud.js';
import {OrdinacijaListComponent} from './ordinacijaList.component.js';
import {CardOrdinacijaComponent} from './cardOrdinacija.component.js';
import {OrdinacijaDetailsComponent} from './ordinacijaDetails.component.js';
import {OrdinacijaCreateComponent} from './ordinacijaCreate.component.js';
import {OrdinacijaEditComponent} from './ordinacijaEdit.component.js';
import {OrdinacijaFormComponent} from './ordinacijaForm.component.js';

const ordinacija = angular.module('ordinacija', [uiPagination, uiModal, crud.name]);

ordinacija.component('ordinacijaList', OrdinacijaListComponent);
ordinacija.component('cardOrdinacija', CardOrdinacijaComponent);
ordinacija.component('ordinacijaDetails', OrdinacijaDetailsComponent);
ordinacija.component('ordinacijaCreate', OrdinacijaCreateComponent);
ordinacija.component('ordinacijaEdit', OrdinacijaEditComponent);
ordinacija.component('ordinacijaForm', OrdinacijaFormComponent);

export {ordinacija};



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacija.js